import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Achievements.css';

const Achievements = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    const [translateX, setTranslateX] = useState(0);

    // Auto-scroll animation
    useEffect(() => {
        const interval = setInterval(() => {
            setTranslateX(prev => prev + 0.5);
        }, 50);

        return () => clearInterval(interval);
    }, []);

    // Your actual achievements data
    const achievements = [
        {
            id: 1,
            title: 'Global Finalist: NASA Space Apps Challenge 2024',
            description: 'Global Finalist at NASA Space Apps Challenge for innovation and execution.',
            image: 'https://res.cloudinary.com/djnqexy8g/image/upload/v1771153544/global_finalist_dtlyxe.jpg'
        },
        {
            id: 2,
            title: 'Finalist: Smart India Hackathon 2024',
            description: 'Selected as a finalist among 500+ submissions at Smart India Hackathon 2024.',
            image: 'https://res.cloudinary.com/djnqexy8g/image/upload/v1771153544/sih_2024_zuxdwk.jpg'
        },
        {
            id: 3,
            title: 'Winner – Smart India Hackathon-2025',
            description: 'Achieved first place at Smart India Hackathon through technical innovation and strong collaboration.',
            image: 'https://res.cloudinary.com/djnqexy8g/image/upload/v1771083389/sih_kecfto.jpg'
        },
        {
            id: 4,
            title: 'MAFFICK 2023 - Informal Anchor',
            description: 'Managed stage hosting as an informal anchor during MAFFICK 2023.',
            image: 'https://res.cloudinary.com/djnqexy8g/image/upload/v1771153545/maffick_kvbfjr.jpg'
        },
        {
            id: 5,
            title: '2nd Place – NASA Space Apps Challenge (Local Event)',
            description: 'Secured Runner-up position at the NASA Space Apps Challenge local event.',
            image: 'https://res.cloudinary.com/djnqexy8g/image/upload/v1771153544/nasa_space_apps_illfva.jpg'
        },
        {
            id: 6,
            title: 'First Place – Shabdsamrat Elocution Competition',
            description: 'Stood first in the Shabdsamrat Elocution Competition conducted by Career Katta.',
            image: 'https://res.cloudinary.com/djnqexy8g/image/upload/v1771154609/shabdsamrat_awmqwq.jpg'
        },
        {
            id: 7,
            title: 'Open Source Contributor OpenCodeIITB\'25 and GSSoC\'25',
            description: 'Contributed to open source projects during OpenCodeIITB\'25 and GSSoC\'25, improving coding skills.',
            image: 'https://res.cloudinary.com/djnqexy8g/image/upload/v1771154120/gssoc_gaei64.jpg'
        },
        {
            id: 8,
            title: 'Deshdoot Samvad Katta Podcast',
            description: 'Participated in a discussion on AI at Deshdoot Samvad Katta.',
            image: 'https://res.cloudinary.com/djnqexy8g/image/upload/v1771153544/deshdoot_vysavh.jpg'
        }
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: 'easeOut',
            },
        },
    };

    return (
        <section id="achievements" className="achievements section">
            <div className="achievements-container">
                <motion.div
                    ref={ref}
                    variants={containerVariants}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                >
                    <motion.h2 className="section-title" variants={itemVariants}>
                        Achievements
                    </motion.h2>

                    <motion.p className="achievements-subtitle" variants={itemVariants}>
                        Milestones and accomplishments from my journey
                    </motion.p>

                    <motion.div
                        className="achievements-wrapper"
                        variants={itemVariants}
                    >
                        <div className="achievements-rotated-container">
                            {/* First Row */}
                            <div
                                className="achievements-row"
                                style={{ transform: `translateX(-${translateX % 400}px)` }}
                            >
                                {[...achievements, ...achievements].map((achievement, index) => (
                                    <div
                                        key={`row1-${index}`}
                                        className="achievement-card"
                                    >
                                        <img
                                            src={achievement.image}
                                            alt={achievement.title}
                                            className="achievement-image"
                                            loading="lazy"
                                        />
                                        <div className="achievement-overlay">
                                            <h3 className="achievement-title">{achievement.title}</h3>
                                            <p className="achievement-description">{achievement.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Second Row */}
                            <div
                                className="achievements-row achievements-row-reverse"
                                style={{ transform: `translateX(${translateX % 400}px)` }}
                            >
                                {[...achievements.slice().reverse(), ...achievements.slice().reverse()].map((achievement, index) => (
                                    <div
                                        key={`row2-${index}`}
                                        className="achievement-card"
                                    >
                                        <img
                                            src={achievement.image}
                                            alt={achievement.title}
                                            className="achievement-image"
                                            loading="lazy"
                                        />
                                        <div className="achievement-overlay">
                                            <h3 className="achievement-title">{achievement.title}</h3>
                                            <p className="achievement-description">{achievement.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default Achievements;